import {makeStyles} from "@material-ui/core/styles";

// SSS ekranlarinin ortak gorsel dili (Meta Tag yonetimi ile ayni token'lar):
// kirmizi #d71f26, kenarlik #eaedf3, baslik #2d3748, ikincil metin #8492a6.
export const faqStyles = makeStyles((theme) => ({
    // --- Liste basligi ---
    listHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        flexWrap: 'wrap',
        marginBottom: 20,
        padding: '16px 20px',
        borderRadius: 14,
        background: '#fff',
        border: '1px solid #eaedf3',
        boxShadow: '0 1px 3px rgba(45, 55, 72, 0.05)',
        [theme.breakpoints.down('xs')]: {
            padding: '14px 16px',
            gap: 12,
        },
    },
    listHeaderIcon: {
        width: 44,
        height: 44,
        borderRadius: 12,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #d71f26 0%, #e8484f 100%)',
        color: '#fff',
        fontSize: 18,
        boxShadow: '0 4px 12px rgba(215, 31, 38, 0.25)',
        [theme.breakpoints.down('xs')]: {
            width: 38,
            height: 38,
            borderRadius: 10,
            fontSize: 16,
        },
    },
    listHeaderText: {
        flex: 1,
        minWidth: 240,
        [theme.breakpoints.down('xs')]: {
            minWidth: 0,
            flexBasis: 'calc(100% - 50px)',
        },
    },
    listHeaderTitleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
    },
    listHeaderCount: {
        fontSize: 16,
        fontWeight: 700,
        color: '#2d3748',
        letterSpacing: 0.2,
    },
    listHeaderDesc: {
        fontSize: 13,
        color: '#8492a6',
        marginTop: 4,
        lineHeight: 1.5,
        maxWidth: 720,
    },
    dragHint: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        fontSize: 12,
        color: '#7b8794',
        background: '#f1f4f9',
        border: '1px solid #e4e9f0',
        borderRadius: 20,
        padding: '5px 14px',
        marginBottom: 14,
    },

    // --- Ana buton (Yeni Soru) ---
    primaryBtn: {
        background: 'linear-gradient(135deg, #d71f26 0%, #e8484f 100%)',
        color: '#fff !important',
        borderRadius: 22,
        padding: '9px 24px',
        fontWeight: 700,
        fontSize: 14,
        textTransform: 'none',
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        boxShadow: '0 4px 14px rgba(215, 31, 38, 0.28)',
        transition: 'all 0.2s ease',
        '&:hover': {
            boxShadow: '0 6px 20px rgba(215, 31, 38, 0.38)',
            transform: 'translateY(-1px)',
            color: '#fff !important',
            textDecoration: 'none',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            justifyContent: 'center',
        },
    },

    // --- Bos durum ---
    emptyCard: {
        border: '1px dashed #d8dee9',
        borderRadius: 16,
        background: '#fff',
        padding: '64px 24px',
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
            padding: '44px 18px',
        },
    },
    emptyIconWrap: {
        width: 76,
        height: 76,
        borderRadius: '50%',
        margin: '0 auto 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #fdecec 0%, #fff5f5 100%)',
        color: '#d71f26',
        fontSize: 30,
    },
    emptyTitle: {
        fontSize: 17,
        fontWeight: 700,
        color: '#2d3748',
        marginBottom: 8,
    },
    emptyDesc: {
        fontSize: 13,
        color: '#8492a6',
        maxWidth: 460,
        margin: '0 auto 24px',
        lineHeight: 1.6,
    },

    // --- Liste satiri ---
    item: {
        border: '1px solid #eaedf3',
        borderRadius: 14,
        background: '#fff',
        marginBottom: 12,
        transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
        '&:hover': {
            borderColor: '#dfe4ee',
            boxShadow: '0 4px 16px rgba(45, 55, 72, 0.08)',
        },
    },
    itemDragging: {
        boxShadow: '0 12px 28px rgba(45, 55, 72, 0.16)',
        borderColor: '#d71f26',
    },
    itemRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        padding: '14px 18px',
        // Mobilde tek satira sigmiyor: ust satirda tutamac/sira/durum/aksiyonlar,
        // soru-cevap ve dil rozetleri alt satirda tam genislikte.
        [theme.breakpoints.down('xs')]: {
            flexWrap: 'wrap',
            gap: 10,
            padding: '12px 14px',
        },
    },
    dragHandle: {
        cursor: 'grab',
        color: '#cbd2dd',
        touchAction: 'none',
        padding: '4px 2px',
        display: 'flex',
        alignItems: 'center',
        transition: 'color 0.2s ease',
        '&:hover': {
            color: '#d71f26',
        },
        '&:active': {
            cursor: 'grabbing',
        },
    },
    orderBadge: {
        minWidth: 30,
        height: 30,
        borderRadius: 9,
        background: '#f5f7fa',
        color: '#5a6779',
        fontWeight: 700,
        fontSize: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    itemBody: {
        flex: 1,
        minWidth: 0,
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            order: 5,
            flexBasis: '100%',
            width: '100%',
        },
    },
    question: {
        fontWeight: 600,
        fontSize: 14,
        color: '#2d3748',
        lineHeight: 1.45,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        wordBreak: 'break-word',
    },
    questionEmpty: {
        color: '#a0aec0',
        fontStyle: 'italic',
    },
    answerPreview: {
        fontSize: 13,
        color: '#8492a6',
        marginTop: 3,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    answerFull: {
        fontSize: 13,
        color: '#4a5568',
        lineHeight: 1.7,
        whiteSpace: 'pre-line',
        background: '#fafbfc',
        border: '1px solid #eef1f6',
        borderRadius: 10,
        padding: '12px 14px',
        margin: '0 18px 16px 62px',
        [theme.breakpoints.down('xs')]: {
            margin: '0 14px 14px',
        },
    },
    langChipRow: {
        display: 'flex',
        gap: 6,
        flexWrap: 'wrap',
        marginTop: 9,
    },
    langChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        height: 22,
        padding: '0 9px',
        borderRadius: 11,
        border: '1px solid #eaedf3',
        background: '#fff',
        color: '#5a6779',
        fontSize: 11,
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        '&:hover': {
            borderColor: '#d71f26',
            color: '#d71f26',
        },
    },
    langChipActive: {
        background: '#fdecec',
        borderColor: '#f5c2c4',
        color: '#d71f26',
    },
    langChipFlag: {
        width: 16,
        height: 12,
        borderRadius: 2,
        objectFit: 'cover',
    },
    statusChip: {
        fontWeight: 700,
        fontSize: 10,
        letterSpacing: 0.3,
        height: 22,
        flexShrink: 0,
    },
    statusPublish: {
        background: '#e7f6ec',
        color: '#1e7e34',
    },
    statusPreview: {
        background: '#fdf3e3',
        color: '#b26a00',
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        flexShrink: 0,
        [theme.breakpoints.down('xs')]: {
            marginLeft: 'auto',
        },
    },
    iconBtn: {
        width: 34,
        height: 34,
        borderRadius: 10,
        color: '#8492a6',
        fontSize: 13,
        '&:hover': {
            background: '#f5f7fa',
            color: '#d71f26',
        },
    },
    expandIcon: {
        color: '#a0aec0',
        fontSize: 12,
        transition: 'transform 0.2s ease',
    },
    expandIconOpen: {
        transform: 'rotate(180deg)',
    },

    // --- Form ---
    panel: {
        borderRadius: 14,
        overflow: 'hidden',
        border: '1px solid #eaedf3',
        background: '#fff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    },
    panelHeader: {
        padding: '16px 22px',
        borderBottom: '1px solid #eaedf3',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 16,
        [theme.breakpoints.down('xs')]: {
            padding: '14px 16px',
            gap: 12,
        },
    },
    panelTitle: {
        fontWeight: 700,
        fontSize: 15,
        color: '#2d3748',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
    },
    progressWrap: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        minWidth: 220,
        [theme.breakpoints.down('xs')]: {
            minWidth: 0,
            width: '100%',
            order: 3,
        },
    },
    progressBar: {
        flex: 1,
        height: 6,
        borderRadius: 3,
        background: '#eef1f6',
        overflow: 'hidden',
    },
    progressFill: {
        height: '100%',
        borderRadius: 3,
        background: 'linear-gradient(90deg, #d71f26 0%, #e8484f 100%)',
        transition: 'width 0.3s ease',
    },
    progressText: {
        fontSize: 12,
        color: '#8492a6',
        fontWeight: 600,
        whiteSpace: 'nowrap',
    },
    statusSelect: {
        minWidth: 168,
        '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            background: '#fafbfc',
        },
        [theme.breakpoints.down('xs')]: {
            minWidth: 0,
            width: '100%',
            order: 2,
        },
    },
    langTabsBar: {
        background: '#fff',
        boxShadow: 'none',
        borderBottom: '2px solid #eef1f6',
        color: '#000',
    },
    langTab: {
        textTransform: 'none',
        minWidth: 104,
        fontWeight: 500,
        fontSize: 13,
        opacity: 0.75,
        '&.Mui-selected': {
            opacity: 1,
            fontWeight: 700,
        },
    },
    langTabIndicator: {
        backgroundColor: '#d71f26',
        height: 3,
        borderRadius: '3px 3px 0 0',
    },
    flagImg: {
        width: 26,
        height: 20,
        borderRadius: 3,
        objectFit: 'cover',
        marginRight: 9,
    },
    tabPanelContent: {
        padding: '22px 24px 8px',
        [theme.breakpoints.down('xs')]: {
            padding: '18px 16px 4px',
        },
    },
    fieldRow: {
        marginBottom: 18,
    },
    inputField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            background: '#fafbfc',
            transition: 'all 0.2s ease',
            '&:hover': {
                background: '#f5f6f8',
            },
            '&.Mui-focused': {
                background: '#fff',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#d71f26',
                    borderWidth: 2,
                },
            },
        },
        '& .MuiInputLabel-outlined.Mui-focused': {
            color: '#d71f26',
        },
    },
    fieldFooter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        marginTop: 5,
    },
    fieldHint: {
        fontSize: 12,
        color: '#8492a6',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    charCounter: {
        fontSize: 12,
        color: '#a0aec0',
        whiteSpace: 'nowrap',
    },
    previewCard: {
        margin: '4px 24px 20px',
        border: '1px solid #eef1f6',
        borderRadius: 12,
        background: '#fafbfc',
        padding: '14px 16px',
        [theme.breakpoints.down('xs')]: {
            margin: '4px 16px 16px',
        },
    },
    previewLabel: {
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.6,
        textTransform: 'uppercase',
        color: '#a0aec0',
        marginBottom: 10,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    previewQuestion: {
        fontSize: 14,
        fontWeight: 700,
        color: '#2d3748',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
    },
    previewAnswer: {
        fontSize: 13,
        color: '#5a6779',
        lineHeight: 1.7,
        marginTop: 8,
        paddingLeft: 22,
        whiteSpace: 'pre-line',
    },
    saveArea: {
        padding: '16px 24px',
        borderTop: '1px solid #eaedf3',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 12,
        background: '#fafbfc',
        flexWrap: 'wrap',
        [theme.breakpoints.down('xs')]: {
            padding: '14px 16px',
            justifyContent: 'space-between',
        },
    },
    cancelBtn: {
        borderRadius: 10,
        padding: '9px 24px',
        fontWeight: 600,
        textTransform: 'none',
        fontSize: 14,
        color: '#5a6779',
        textDecoration: 'none',
        '&:hover': {
            background: '#eef1f6',
            textDecoration: 'none',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '9px 16px',
        },
    },
    // Tum SSS sayfalarindaki tam sayfa yukleniyor gostergesi. Sayfa yuksekligi icerige
    // gore degistigi icin ekrana sabitlenip ortalanir (Meta Tag ekranindaki desen).
    loadingBox: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: theme.zIndex.drawer,
    },
    // Global `.MuiCircularProgress-indeterminate { position:absolute !important; top:23% !important }`
    // (styles.scss) spinner'i akistan cikariyor; butonda yazinin ustune biniyor, kutuda kayiyor.
    // Iki class'li secici + !important ile sadece SSS ekranlarinda geri alinir.
    spinner: {
        '&.MuiCircularProgress-indeterminate': {
            position: 'relative !important',
            top: 'auto !important',
        },
    },
    // Panel/kart icindeki yukleniyor gostergesi (sayfa yuksekligini sismez).
    loadingBoxInline: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: 220,
        padding: theme.spacing(4, 3),
    },
}));

export default faqStyles;
